import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { Button, Heading } from 'react-aria-components'
import { Icon } from '#app/components/media/icon'
import { cn } from '#app/utils/tailwind-merge.ts'

type CollapsibleProps = HTMLAttributes<HTMLDetailsElement> & {
	isExpanded?: boolean
	defaultExpanded?: boolean
}

const Collapsible = forwardRef<HTMLDetailsElement, CollapsibleProps>(({ className, children, defaultExpanded, isExpanded, ...props }, ref) => {
	return (
		<details ref={ref} className={cn('collapsible', className)} open={isExpanded ?? defaultExpanded} {...props}>
			{children}
		</details>
	)
})
Collapsible.displayName = 'Collapsible'

const CollapsibleTrigger = forwardRef<HTMLButtonElement, { children: ReactNode }>(({ children, ...props }, ref) => {
	return (
		<summary className="collapsible-heading list-none" {...props}>
			<Heading className="collapsible-heading">
				<Button slot="trigger" className="collapsible-button">
					<Icon name="chevron-right" className="collapsible-icon" />
					{children}
				</Button>
			</Heading>
		</summary>
	)
})
CollapsibleTrigger.displayName = 'CollapsibleTrigger'

const CollapsibleContent = forwardRef<HTMLDivElement, { className?: string; children: ReactNode }>(({ className, ...props }, ref) => {
	return <div ref={ref} className={cn('collapsible-content', className)} {...props} />
})
CollapsibleContent.displayName = 'CollapsibleContent'

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
